var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCtaHandRight = function SvgCtaHandRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 316 307"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#82D8F6",
    d: "m.838 247.283 83.9 58.797 58.796-83.9-83.9-58.797z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB6BD9",
    strokeLinecap: "round",
    strokeWidth: 3.182,
    d: "M291.316 172.174c-8.982-3.967-32.017-17.59-42.245-15.036-15.396 3.843-21.557 19.58-29.342 32.326-10.617 17.382-35.688 33.679-55.788 36.14-20.154 2.468-39.195-1.284-42.128-8.104-1.047-2.433-.044-5.256 3.687-8.326 3.968-3.265 11.022-6.809 21.981-10.462 31.476-10.491 41.959-37.749 16.46-50.531-7.411-3.715-15.785-6.964-23.801-9.031-8.731-2.251-15.134-2.158-23.779-1.662-13.706.787-30.698 10.125-40.193 19.684-5.363 5.4-8.168 11.805-9.94 19.041-.717 2.923-.783 6.568-3.097 8.708-23.218 21.469-24.453-27.656-10.945-42.213 9.357-10.083 21.497-24.362 34.899-28.805 15.268-5.062 32.517-7.189 48.238-3.257M55.518 122.218c2.008-16.489 9.053-47.347 50.533-52.717"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB6BD9",
    strokeLinecap: "round",
    strokeWidth: 3.182,
    d: "M47.493 150.095c2.3-16.451 7.334-31.99 19.96-42.709 12.508-10.618 28.835-18.927 45.127-19.698"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#BB6BD9",
    strokeLinecap: "round",
    strokeWidth: 3.182,
    d: "M80.453 77.408c8.64-14.849 21.241-22.066 39.566-27.253 60.231-17.05 161.07 50.88 193.05 77.526l-21.649 44.425"
  })));
};
export default SvgCtaHandRight;